/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_register__car__construction_year = /** @type {(inputs: {}) => string} */ () => {
	return `Jahr`
};

const en_register__car__construction_year = /** @type {(inputs: {}) => string} */ () => {
	return `Year`
};

const es_register__car__construction_year = /** @type {(inputs: {}) => string} */ () => {
	return `Año`
};

const fr_register__car__construction_year = /** @type {(inputs: {}) => string} */ () => {
	return `Année`
};

const it_register__car__construction_year = /** @type {(inputs: {}) => string} */ () => {
	return `Anno`
};

const nl_register__car__construction_year = /** @type {(inputs: {}) => string} */ () => {
	return `Jaar`
};

const pt_register__car__construction_year = /** @type {(inputs: {}) => string} */ () => {
	return `Ano`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register__car__construction_year = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register__car__construction_year(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register__car__construction_year", locale)
	if (locale === "de") return de_register__car__construction_year(inputs)
	if (locale === "en") return en_register__car__construction_year(inputs)
	if (locale === "es") return es_register__car__construction_year(inputs)
	if (locale === "fr") return fr_register__car__construction_year(inputs)
	if (locale === "it") return it_register__car__construction_year(inputs)
	if (locale === "nl") return nl_register__car__construction_year(inputs)
	return pt_register__car__construction_year(inputs)
};